import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";
import Checkbox from "@mui/material/Checkbox";
import MDBadge from "components/MDBadge";

function CoPaysTableData({ data, selectedIds, onToggle, onEdit, onDelete }) {
  const columns = [
    { Header: "", accessor: "checkbox", align: "center", width: "5%" },
    { Header: "Code", accessor: "code", align: "left" },
    { Header: "Description", accessor: "description", align: "left" },
    { Header: "Benefit", accessor: "benefit", align: "left" },
    { Header: "Amount", accessor: "amount", align: "right" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  const rows = (data || []).map((item) => ({
    checkbox: (
      <Checkbox
        size="small"
        checked={selectedIds.includes(item.id)}
        onChange={() => onToggle(item.id)}
      />
    ),
    code: (
      <MDTypography variant="caption" fontWeight="bold">
        {item.code}
      </MDTypography>
    ),
    description: (
      <MDTypography variant="caption" color="text">
        {item.description}
      </MDTypography>
    ),
    benefit: (
      <MDTypography variant="caption" color="text">
        {item.benefit}
      </MDTypography>
    ),
    amount: (
      <MDTypography variant="caption" color="text">
        {item.fixedAmountByBeneficiary?.toLocaleString()}
      </MDTypography>
    ),
    status: (
      <MDBadge
        badgeContent={item.status}
        size="md"
        color={item.status === "active" ? "success" : "error"}
        container
      />
    ),
    action: (
      <div>
        <IconButton size="small" onClick={() => onEdit(item)}>
          <Icon>edit</Icon>
        </IconButton>
        <IconButton size="small" color="error" onClick={() => onDelete(item)}>
          <Icon>delete</Icon>
        </IconButton>
      </div>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted={false}
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
      size="small"
    />
  );
}

CoPaysTableData.propTypes = {
  data: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CoPaysTableData;
